import { render } from "./Header.vue?vue&type=template&id=56e6229b&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=56e6229b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e6229b"]])

export default __exports__